import { createContext, useContext } from "react";

const RouteFrozenContext = createContext(false);

/** True on the page copy that is only playing the exit animation. */
export const useRouteFrozen = () => useContext(RouteFrozenContext);

export default RouteFrozenContext;
